// Copyright (c) 2016 Deere & Company

import DeliveryNoDocuments from '../../../reports/delivery-no-documents/state-connector';

export default {
    component: DeliveryNoDocuments,
    name: 'DELIVERY_NO_DOCUMENTS',
    path: 'delivery-no-documents'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/delivery-no-documents.js